<template>
    <div v-show="visible">
        <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="450px">    
           <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item prop="moduleId" label="评价模块">
                    <el-select v-model="form.moduleId" multiple placeholder="评价模块" clearable >
                        <el-option
                            v-for="item in evaluateModules"
                            :key="item.moduleId"
                            :label="item.moduleTitle"
                            :value="item.moduleId">
                        </el-option>
                    </el-select>
                </el-form-item> 
           
                <el-form-item  prop="" label="评价审核人">
                    <el-button @click="getMoreUser()">{{form.receiveTaskUsersLabel}}</el-button>
                </el-form-item> 

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框多人 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import userTransfer from '../../sys/user/UserTransfer.vue';
    import { MessageBox } from 'element-ui';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        name:"",
        data(){
            return{
                visible:false,
                transferVisible:false,
                form:{
                    deptId:"",
                    moduleId:"",
                    receiveTaskUsers:[],
                    receiveTaskUsersLabel:"",
                },
                evaluateModules:[],
                rules: {
                    moduleId: [
                        { required: true, message: '请选择评价模块', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        components: {
            userTransfer
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(deptId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.deptId=deptId;
                this.form.receiveTaskUsers=[];
                this.form.receiveTaskUsersLabel="请选择";
                // 初始数据
                this.getModuleBindIndicators();
            },
            //获取评价模块
           getModuleBindIndicators(){
                let url  = this.moduleBindIndicatorsListModuleUrl;
                let data = {
                    deptId:this.form.deptId,
                };
                
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data))
                    if(res.status==200){
                        this.evaluateModules = res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                });
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        
                        // 评价审核人不可为空
                        // if(this.form.receiveTaskUsers == ''){
                        //     this.$commonFn.showTip('评价审核人不可为空',3);
                        //     return;
                        // }

                        // 获取评价模块ID与模块名称
                        let moduleId=[];
                        let moduleTitle=[];
                        for(let i = 0; i < this.form.moduleId.length; i++) {
                            let obj = this.evaluateModules.find((item) => {
                                return item.moduleId === this.form.moduleId[i]
                            })
                            // console.log(obj.moduleId+","+obj.moduleTitle);
                            moduleId.push(obj.moduleId);
                            moduleTitle.push(obj.moduleTitle);
                        }

                        // 评价审核人
                        let receiveTaskUsers = this.$util.isEmpty(this.form.receiveTaskUsers)? '' : this.form.receiveTaskUsers.join(',')

                        let url= this.evaluateCheckuserSetSaveUrl;
                        let data = {
                            deptId:this.form.deptId,
                            moduleId:moduleId.join(','),
                            moduleTitle:moduleTitle.join(','),
                            checkUsers:receiveTaskUsers,
                        };

                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });

                    }
                });
            },
            getMoreUser(){
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.form.receiveTaskUsers.length > 0){
                        this.$refs['userTransfer'].init(2,this.form.receiveTaskUsers,2,this.form.deptId);
                    }else{
                        this.$refs['userTransfer'].init(2,null,2,this.form.deptId);
                    }
                })
            },
            setUser(key,label){
                this.form.receiveTaskUsers = key;
                this.form.receiveTaskUsersLabel = key.length+"人";
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/checkUserSet/Add.vue